// Gift Card Media
(function() {
  function formatMoney(cents) {
    return window.FoxTheme?.Currency?.formatMoney?.(cents) || `$${(cents / 100).toFixed(2)}`;
  }

  function updateGiftCardImage(element, imageData) {
    const img = element.querySelector('.gift-card__image');
    const wrapper = element.querySelector('.gift-card__image-wrapper');
    const zoomBtn = element.querySelector('.gift-card__zoom-btn');

    if (img) {
      img.src = imageData.src;
      img.alt = imageData.alt;
      img.width = imageData.width;
      img.height = imageData.height;
    }

    if (wrapper) wrapper.dataset.currentImageId = imageData.id;

    if (zoomBtn) {
      zoomBtn.dataset.src = imageData.zoom_src;
      zoomBtn.dataset.pswpWidth = imageData.width;
      zoomBtn.dataset.pswpHeight = imageData.height;
    }

    element.querySelectorAll('[is="image-lazy"]').forEach(img => img.loadImage?.());
  }

  function updateGiftCardPrice(variantData) {
    const formattedPrice = formatMoney(variantData.price);
    
    document.querySelectorAll('.f-price-item--regular, .f-price-item--sale, .price__current, [class*="price"]').forEach(priceElement => {
      if (!priceElement.querySelector('*')) {
        priceElement.textContent = formattedPrice;
      }
    });
  }

  function initializeGiftCardZoom(element) {
    if (!window.FoxTheme?.PhotoSwipeLightbox) return;

    const zoomBtn = element.querySelector('.gift-card__zoom-btn');
    if (!zoomBtn) return;

    if (element.lightbox) element.lightbox.destroy();

    element.lightbox = new window.FoxTheme.PhotoSwipeLightbox({
      dataSource: [{
        id: '0',
        src: zoomBtn.dataset.src,
        width: parseInt(zoomBtn.dataset.pswpWidth) || 1000,
        height: parseInt(zoomBtn.dataset.pswpHeight) || 1000,
        mediaType: 'image'
      }],
      pswpModule: window.FoxTheme.PhotoSwipe,
      bgOpacity: 1,
      arrowPrev: false,
      arrowNext: false,
      zoom: true,
      close: true,
      counter: false,
      preloader: false
    });

    zoomBtn.onclick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      if (window.innerWidth <= 767) {
        // Mobile requires double-tap to prevent accidental zooms
        element.clickCount = (element.clickCount || 0) + 1;
        if (element.clickCount === 1) {
          element.clickTimer = setTimeout(() => element.clickCount = 0, 300);
        } else if (element.clickCount === 2) {
          clearTimeout(element.clickTimer);
          element.clickCount = 0;
          element.lightbox.loadAndOpen(0);
        }
      } else {
        element.lightbox.loadAndOpen(0);
      }
    };

    element.lightbox.init();
  }

  function handleGiftCardVariantChange(event) {
    const variant = event.detail?.variant;
    if (!variant?.id) return;

    document.querySelectorAll('gift-card-media').forEach(giftCardElement => {
      const productId = giftCardElement.dataset.productId;
      const variantData = window.giftCardVariants?.[productId]?.[variant.id];
      
      if (variantData) {
        if (variantData.image) {
          updateGiftCardImage(giftCardElement, variantData.image);
          if (giftCardElement.dataset.enableImageZoom === 'true') {
            initializeGiftCardZoom(giftCardElement);
          }
        }
        
        requestAnimationFrame(() => updateGiftCardPrice(variantData));
      }
    });
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('gift-card-media')) {
      const productInfo = event.target.querySelector('product-info');
      if (productInfo) productInfo.dataset.skipPriceUpdate = 'true';
    }
  });

  document.addEventListener('variant:changed', handleGiftCardVariantChange);

  if (!customElements.get('gift-card-media')) {
    customElements.define('gift-card-media', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.enableImageZoom === 'true') {
          initializeGiftCardZoom(this);
        }
      }

      disconnectedCallback() {
        if (this.lightbox) this.lightbox.destroy();
      }
    });
  }

})();